'use client';

import Script from 'next/script';

import React, { ReactNode } from 'react';

import CheckRequireUserData from '@shared/common/components/CheckRequireUserData/CheckRequireUserData';
import Device from '@shared/common/components/Device';
import { Footer } from '@shared/common/components/Footer';
import { NavLayout } from '@shared/common/components/NavLayout';
import {
  launchpadEatsNavItem,
  launchpadHowItWorksNavItem,
  launchpadIdoSalesNavItem,
  launchpadPrimaryNav,
} from '@shared/common/components/NavLayout/navSetting';
import { NavLayoutLinkBase } from '@shared/common/components/NavLayout/types';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useBanxaModal, useSupportModal } from '@shared/common/providers/GlobalModalsProvider';
import { getProcessEnvGlobalConfig } from '@shared/config/global';

import { useAuthModal } from '@launchpad/components/ui/buttons/ConnectWalletButton';
import { Launchpad } from '@ui/uikit/components/logos/Launchpad';

const quickNavItems: NavLayoutLinkBase[] = [
  launchpadIdoSalesNavItem,
  {
    ...launchpadEatsNavItem,
    label: 'EATS',
  },
  launchpadHowItWorksNavItem,
];

const MainLayout = ({ children }: { children: ReactNode }) => {
  const isDev = getProcessEnvGlobalConfig('isDev');
  const { user, logout, userEvmWallet } = useAuth();
  const modal = useBanxaModal();
  const supportModal = useSupportModal();
  const { login } = useAuthModal();

  const handleConnectClick = async () => {
    await login();
  };

  const handleBanxaBuyToken = () => {
    modal.open({
      walletAddress: userEvmWallet?.attributes.address,
    });
  };

  return (
    <>
      <NavLayout
        Logo={Launchpad}
        user={user ? { data: user } : undefined}
        onLogin={handleConnectClick}
        onLogout={logout}
        primaryNavItems={launchpadPrimaryNav}
        quickNavItems={quickNavItems}
        primaryNavMenuTitle="Magic Launchpad"
        showKyc
        onBanxaBuyToken={handleBanxaBuyToken}
        onSupport={supportModal.open}
      >
        {children}

        <Footer withDisclaimer />
      </NavLayout>
      <CheckRequireUserData user={user} />

      <Script src="https://accounts.google.com/gsi/client" async defer strategy="lazyOnload" />

      <Device>
        {({ isMobile }) =>
          isMobile &&
          isDev && (
            <Script
              src="https://cdn.jsdelivr.net/npm/eruda"
              onLoad={() => {
                // Initialize Eruda (devtools for mobile)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                eruda.init();
              }}
            />
          )
        }
      </Device>
    </>
  );
};

export default MainLayout;
